import {
  GridActionsCellItem,
  GridColumns,
  GridRowParams
} from '@mui/x-data-grid'
import { Row } from 'react-data-grid'
import { AiOutlineEye } from 'react-icons/ai'
import { FiTrash } from 'react-icons/fi'
import { HiOutlinePencil } from 'react-icons/hi'
import * as produtoActions from 'store/modules/backoffice/produto/actions'

const headerTheme = 'table-header--purple'

export const COLUMNS: GridColumns<Row> = [
  {
    field: 'descricaoProduto',
    headerName: 'Produto',
    headerClassName: headerTheme,
    align: 'left',
    headerAlign: 'left',
    flex: 1
  },
  {
    field: 'descricaoBanco',
    headerName: 'Instiuição',
    headerClassName: headerTheme,
    align: 'left',
    headerAlign: 'left',
    flex: 1
  },
  {
    field: 'descricaoConvenio',
    headerName: 'Convênio',
    headerClassName: headerTheme,
    align: 'left',
    headerAlign: 'left',
    flex: 1
  },
  {
    field: 'descricaoTipoOperacao',
    headerName: 'Tipo operação Riber',
    headerClassName: headerTheme,
    align: 'left',
    headerAlign: 'left',
    flex: 1
  },
  {
    field: 'descricaoTipoFormalizacao',
    headerName: 'Tipo de formalização',
    headerClassName: headerTheme,
    align: 'left',
    headerAlign: 'left',
    flex: 1
  },
  {
    field: 'actions',
    headerName: 'Ações',
    headerClassName: headerTheme,
    type: 'actions',
    align: 'center',
    getActions: (params: GridRowParams) => [
      <GridActionsCellItem
        key={params.row.id}
        icon={<AiOutlineEye />}
        onClick={() => {
          produtoActions.visualizarParametrizacaoDispatchSaga(params.row.id)
        }}
        label="Visualizar"
      />,
      <GridActionsCellItem
        key={params.row.id}
        icon={<HiOutlinePencil />}
        onClick={() => {
          produtoActions.editarParametrizacaoDispatchSaga(params.row.id)
        }}
        label="Editar"
      />,
      <GridActionsCellItem
        key={params.row.id}
        icon={<FiTrash />}
        onClick={() => {
          produtoActions.setItemSelectedIdDispatch(params.row.id)
          produtoActions.toggleModalExclusaoDispatch(true)
        }}
        label="Deletar"
      />
    ]
  }
]
